module.exports = __webpack_public_path__ + "img/PDAC1_Fibroblasts.beaf35e1.png";